import { getBaseURL } from '../helpers';
export const IMG_LOADING = `${getBaseURL()}/wp-admin/images/loading.gif`;
export const URL_WP_AJAX = `${getBaseURL()}/wp-admin/admin-ajax.php`;
